import * as libLocation from "../lib/location.ts";
import * as Html from "../util/Html.ts";
import * as modal from "../util/modal.ts";
import ApiServer from "../ApiServer.ts";
import * as Storage from "../lib/Storage.ts";
import * as FwDatas from "../FwDatas.ts";
import { markInvalidNative } from "../util/forms.ts";
import * as i18n from "../i18n.ts";

Html.registerDom({
  async emailvalidate(email){
    var what = await modal.askAsPromise({
      title:"verifyEmailModal.title",
      emoji:"💌",
      message:i18n.get("verifyEmailModal.description",email),
      button:[
        {title:"verifyEmailModal.verifyButton",value:"1"},
        {title:"verifyEmailModal.changeButton",class:"secondary",value:"2"},
      ]
    })
    if(what==="1"){
      Html.trigger(this,"emailvalidateok",[email])
    }else if(what==="2"){
      Html.trigger(this,"emailvalidatechange",[email])
    }
  },
  emailvalidateok(email){
    ApiServer.accsendaccountidentifiervalidationcode(null,null,email,null,"TOKEN",function(){
      import("../modal/email_validate_sent.mustache").then(function(tpl){
        modal.closeDomModal();
        modal.closeSnack();
        Storage.sessionSet('emailvalidatedchecked','true');

        const theModal = modal.openDomModal(tpl,{email:email});
        theModal.onClose = function(){
          libLocation.refresh()
        };
      });
    })

  },
  emailvalidatechange(email){
    import("../modal/email_validate_change.mustache").then(function(tpl){
      modal.closeDomModal();
      modal.openDomModal(tpl,{oldEmail:email});
    });
  },
  async emailvalidatechangewithemail(oldEmail){
    const parent = this.parentElement;
    if(!parent) return;
    const input = parent.querySelector('input') as HTMLInputElement;
    if(!input) return;
    const email = input.value;
    try{
      var isAvailable = await ApiServer.log2check('Email',email)
      if (!isAvailable){
        markInvalidNative(input, i18n.get("errors.emailUnavaible"));
      }else{
        import("../modal/email_validate_askpass.mustache").then(function(tpl){
          modal.closeDomModal();
          modal.openDomModal(tpl,{email:email,oldEmail:oldEmail});
        });
      }
    }catch(e){
      markInvalidNative(input, i18n.get("invitationJs.errorEmail") );
    }
  }
});


ApiServer['custom.changeidentifier'] = ApiServer.accchangeaccountidentifier.prepare({validationmethod:"TOKEN"},function(identifier){
  import("../modal/email_validate_sent.mustache").then(function(tpl){
    modal.closeDomModal();
    const theModal = modal.openDomModal(tpl,{email:identifier.value,changed:true});
    theModal.onClose = function(){libLocation.refresh()};
  });
},function(err){
  if(err.code==="3"){
    markInvalidNative(document.querySelector('form[data-fw-dyn-action="custom.changeidentifier"] input[type="password"]'),i18n.get("fw2.apierrors.3"))
  }else{
    throw err;
  }
})

function checkEmailverified() {
  if (Storage.sessionGet('emailvalidatedchecked')!==null) {
    let email = getMainEmailIdentifier()
    if (email && !email.validated) {
      import("../modal/email_validatesnackbar.mustache").then(function(TPL) {
        modal.snack(TPL, { email: email.value }).onClose = function() {
          Storage.sessionSet('emailvalidatedchecked', 'true')
        }
      });
    }
  }
}
//TODO use type AccountIdentifier
function getMainEmailIdentifier():{value:string,validated:boolean}|undefined{
  let
    emails = FwDatas.getUser().identifiers.filter(identifier => identifier.type === 'Email'),
    validated = emails.filter(identifier => identifier.validated),
    notValidated = emails.filter(identifier => !identifier.validated);

  if(validated.length>0){
    return validated[0];
  }
  if(notValidated.length>0){
    return notValidated[0];
  }
}
export {checkEmailverified,getMainEmailIdentifier}